import { API_HOST } from 'src/config-global';
import { AIInputStateControl } from 'src/features/AIInput';
import { Session } from 'src/state';
import {
  AIMessagesTypes,
  TextToSpeechResponse,
  TextToSpeechType,
} from '../AIConversation/hooks/types';

export const useAIMessageQueries = (store: AIInputStateControl) => {
  const { abortController } = store();

  const api = async <R>(path: string, body: R) => {
    const response = await fetch(`${API_HOST}/${path}`, {
      method: 'POST',
      headers: {
        authorization: Session.getToken() || '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
      signal: abortController?.signal,
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return response;
  };

  const getAIResponse = async (params: AIMessagesTypes) => {
    try {
      return api<AIMessagesTypes>('ai/chat/conversation/new-message', params);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const getTTSResponse = async ({ messageId, text }: TextToSpeechType) => {
    try {
      const response = await api('ai/speech/audio.aac', {
        text,
      });
      const blob = await response.blob();
      return { audio: blob, messageId } as TextToSpeechResponse;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return {
    getAIResponse,
    getTTSResponse,
  };
};
